import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronBottom"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0001 15.5859L4.70718 8.29297L3.29297 9.70718L12.0001 18.4143L20.7072 9.70718L19.293 8.29297L12.0001 15.5859Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronBottom;
